<h4>
    Gestión de gráfico de dispersión :
    <ng-container *ngIf="idTier1 === '6'">
        Riesgos
    </ng-container>
    <ng-container *ngIf="idTier1 === '4'">
        Oportunidades
    </ng-container>
</h4>
<br><br>
<div class="container">
    <h6 class="text-start">1. Administrar períodos :</h6>
    <p class="text-start">Seleccionamos el período para poder cargar los riesgos correspondientes a este período. Con el
        botón podemos crear nuevos períodos.</p>

    <div class="row">
        <div class="textOnInput input-group col-4 col-md-4">
            <label class="form-label" for="inputText">Periodos</label>
            <select class="form-select form-input" [(ngModel)]="selectedDate" (change)="onDateSelected(selectedDate)">
                <option selected disabled [ngValue]="null">Periodos...</option>
                <option *ngFor="let date of scatterperiod" [ngValue]="date"> {{ (+date.period) + ' - ' + (+date.period +
                    10) }}</option>
            </select>
            <div class="input-group-append">
                <button class="btn btn-outline-primary" title="Agregar nuevo periodo" type="button"
                    (click)="openModal()" for><i class="fa fa-calendar-plus-o" aria-hidden="true"></i></button>
            </div>
        </div>
    </div>

    <hr><br>
    <h6 class="text-start">2. Administrar puntos :</h6>
    <p class="text-start">Seleccionamos el riesgo para ingresar su probabilidad de ocurrencia y magnitud de impacto;
        ambos valores deben estar en una escala del 1 al 5.</p>
    <div style="text-align: right;">
        <i title="Resetear campos!" class="fa fa-refresh icono-reset" aria-hidden="true"
            style="cursor: pointer; margin-right: 10px;" (click)="resetSettingValues()"></i>
    </div>
    <!--     <div style="text-align: right;">
        <i title="Limpiar los campos!" class="fa fa-eraser icono-limpiar" aria-hidden="true"
            style="cursor: pointer; margin-right: 10px;" (click)="cancel()"></i>
    </div> -->

    <form autocomplete="off" [formGroup]="form" (ngSubmit)="save()">
        <div class="form-group row">
            <div class="textOnInput col-6 col-md-6">
                <ng-container *ngIf="idTier1 === '6'">
                    <label class="form-label" for="inputText">Lista de riesgos</label>
                </ng-container>
                <ng-container *ngIf="idTier1 === '4'">
                    <label class="form-label" for="inputText">Lista de oportunidades</label>
                </ng-container>

                <select class="form-select form-input" formControlName="idtier3">
                    <ng-container *ngIf="idTier1 === '6'">
                        <option selected [ngValue]="null">Riesgos...</option>
                    </ng-container>
                    <ng-container *ngIf="idTier1 === '4'">
                        <option selected [ngValue]="null">Oportunidades...</option>
                    </ng-container>
                    <ng-container *ngFor="let t of t3; let i = index">
                        <option [ngValue]="t.id" [disabled]="Tier3Selected(t.code)"
                            [ngClass]="{ 'disabled-option': Tier3Selected(t.code) }"
                            [class.is-invalid]="campoNoValido('idtier3')">
                            {{t.code}}_{{t.shorttitle}}
                        </option>
                    </ng-container>
                    <small class="text-danger" *ngIf="campoNoValido('idtier3')">Este campo es
                        requerido</small>
                </select>
            </div>

            <div class="textOnInput col-12 col-md-3">
                <label class="form-label" for="inputText">Probabilidad</label>
                <input class="form-control form-input" type="number" formControlName="probabilidad" autocomplete="off"
                    [class.is-invalid]="campoNoValido('probabilidad')" max="5">
                <small class="text-danger" *ngIf="campoNoValido('probabilidad')">Este campo es
                    requerido</small>
            </div>

            <div class="textOnInput col-12 col-md-3">
                <label class="form-label" for="inputText">Impacto</label>
                <input class="form-control form-input" type="number" formControlName="impacto" autocomplete="off"
                    [class.is-invalid]="campoNoValido('impacto')" max="5">
                <small class="text-danger" *ngIf="campoNoValido('impacto')">Este campo es
                    requerido</small>
            </div>

            <div class="textOnInput col-12 col-md-3">
                <label class="form-label" for="inputText">Ajustar punto en x</label>
                <input class="form-control form-input" type="number" formControlName="mp" autocomplete="off" disabled
                    [class.is-invalid]="campoNoValido('mp')">
                <small class="text-danger" *ngIf="campoNoValido('mp')">Este campo es
                    requerido</small>
            </div>

            <div class="textOnInput col-12 col-md-3">
                <label class="form-label tl" for="inputText">Ajustar punto en y</label>
                <input class="form-control form-input" type="number" formControlName="mi" autocomplete="off" disabled
                    [class.is-invalid]="campoNoValido('mi')">
                <small class="text-danger" *ngIf="campoNoValido('mi')">Este campo es
                    requerido</small>
            </div>

            <div class="textOnInput col-12 col-md-3">
                <label class="form-label" for="inputText">Ajustar texto en x</label>
                <input class="form-control form-input" type="number" formControlName="mtx" autocomplete="off" disabled
                    [class.is-invalid]="campoNoValido('mtx')">
                <small class="text-danger" *ngIf="campoNoValido('mtx')">Este campo es
                    requerido</small>
            </div>

            <div class="textOnInput col-12 col-md-3">
                <label class="form-label" for="inputText">Ajustar texto en y</label>
                <input class="form-control form-input" type="number" formControlName="mty" autocomplete="off" disabled
                    [class.is-invalid]="campoNoValido('mty')">
                <small class="text-danger" *ngIf="campoNoValido('mty')">Este campo es
                    requerido</small>
            </div>

            <input type="hidden" formControlName="id">

            <div class="textOnInput col-12">
                <label class="form-label" for="inputText">Visible/oculto</label>
                <div class="label-container align-switch">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="switch1" formControlName="status">
                    </div>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-12">
                <div class="d-flex justify-content-start">
                    <div class="me-2">
                        <button type="button" class="btn btn-outline-secondary btn-block"
                            [routerLink]="getCancelarRouterLink()">
                            Cancelar
                        </button>
                    </div>
                    <div>
                        <button type="submit" class="btn btn-outline-primary">Guardar</button>
                    </div>
                </div>
            </div>
        </div>

    </form>

    <br>
    <hr>
    <h6 class="text-start">3. Visualización puntos :</h6>
    <p class="text-justify">Aquí podemos interactuar con los puntos creados. Al hacer clic en un punto y
        sin soltarlo, podemos ajustar la posición del texto o del cuadrado de color. Una vez que hayamos
        desplazado el texto o el punto de color, procedemos a hacer doble clic sobre el punto para guardar los cambios.
    </p>
    <br>

    <div class="col-sm-12 col-md-12">
        <ng-container *ngIf="scatterpoint && scatterpoint.length > 0">
            <app-adm-scatter (selectedPoint)="handlePuntoSeleccionado($event)" [t3]="t3" [band]="band"
                [scatterpoint]="scatterpoint" [dx1]="dx1" [dx2]="dx2" [dy1]="dy1" [dy2]="dy2"></app-adm-scatter>
        </ng-container>
    </div>
</div>
<app-adm-modal-scatter-period [showModal]="showModal" [idTier1]="idTier1" (onClose)="onModalClose()"
    (onSave)="onModalSave()"></app-adm-modal-scatter-period>